module.exports = __webpack_public_path__ + "img/a7b6055.jpg";